import React from 'react';

import Appointment from './Appointment';

const ConsultForm = ({ data, loading }) => (
    <div className="consult">
        <Appointment data={data && data} loading={loading} className="fadeIn" />
    </div>
);

export default ConsultForm;



// WEBPACK FOOTER //
// ./src/components/Forms/ConsultForm.jsx